import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle } from 'react-icons/fi';

const ProgramIntroLetter = () => {
  return (
    <SalesLetterWrapper>
      <div className="space-y-10">
        <div className="text-center">
          <p className="text-brand-gold font-black uppercase tracking-[0.3em] text-sm mb-6">Introducing:</p>
          <h2 className="text-4xl md:text-6xl font-display font-black text-brand-dark mb-10 leading-tight">
            Simple Online Income <br/>For Retirees
          </h2>
          <p className="text-2xl leading-relaxed">
            A practical step-by-step guide to creating flexible supplemental income online without complicated technology, risky investments, or overwhelming business models.
          </p>
        </div>

        <div className="bg-bg-alt p-10 rounded-[3rem] border border-slate-200">
          <h3 className="text-xl font-bold mb-8 text-brand-dark">This program was designed specifically for retirees who want:</h3>
          <ul className="space-y-4">
            {[
              'more financial breathing room',
              'more flexibility',
              'more confidence online',
              'and more freedom in retirement'
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-4 text-xl font-medium">
                <SafeIcon icon={FiCheckCircle} className="text-brand-green text-2xl" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-6">
          <p className="text-2xl font-black text-brand-dark">Even if you:</p>
          <ul className="space-y-3 italic text-text-secondary text-xl">
            <li>• aren’t “tech savvy”</li>
            <li>• have never worked online before</li>
            <li>• feel overwhelmed by technology</li>
            <li>• or worry you may be “too old” to learn new things</li>
          </ul>
        </div>

        <div className="pt-12 text-center border-t border-slate-100">
          <h3 className="text-3xl font-display font-black text-red-600 uppercase tracking-tighter mb-8">
            This Is NOT One Of Those “Get Rich Quick” Programs
          </h3>
          <p className="text-2xl font-light italic mb-10">
            In fact… One of the first things you’ll learn inside this book is: <span className="text-brand-dark font-black underline decoration-red-400">what to avoid.</span>
          </p>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default ProgramIntroLetter;